import { render, staticRenderFns } from "./ProjectCollectionManager.vue?vue&type=template&id=282b43cb"
import script from "./ProjectCollectionManager.vue?vue&type=script&lang=ts"
export * from "./ProjectCollectionManager.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('282b43cb')) {
      api.createRecord('282b43cb', component.options)
    } else {
      api.reload('282b43cb', component.options)
    }
    module.hot.accept("./ProjectCollectionManager.vue?vue&type=template&id=282b43cb", function () {
      api.rerender('282b43cb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/projects/ProjectCollectionManager.vue"
export default component.exports